export default __webpack_public_path__ + "static/media/icons_info_gender_male.9592999c.svg";